import { getFormatMessage, isAsyncFunction } from '@/utils/utils'
import { Modal, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { BoxImport } from '../import'
import {
  BoxComMode,
  BoxImportModalProps,
  BoxImportSearchItem,
  BoxImportType,
  BoxItem
} from '../interface'

let time

export const BoxImportModal: React.FC<BoxImportModalProps> = (
  props: BoxImportModalProps
) => {
  const {
    visible,
    boxItems,
    importTypes,
    onVisibleChange,
    onImport,
    onSearch,
    onFileSelect,
    onTypeChange
  } = props
  const formatMessage = getFormatMessage()
  const [formResult, setFormResult] = useState<boolean>(false)
  const [checkItems, setCheckItems] = useState<BoxItem[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [type, setType] = useState<BoxImportType>(0)
  const [importLoading, setImportLoading] = useState<boolean>(false)

  const handleSearch = async (item: BoxImportSearchItem) => {
    setLoading(true)
    setType(item.importType)
    if (onSearch) {
      if (isAsyncFunction(onSearch)) {
        try {
          setLoading(true)
          await onSearch(item)
        } finally {
          setLoading(false)
        }
      } else {
        onSearch(item)
        if (time) {
          clearTimeout(time)
        }
        // 最长超时loading时间
        time = setTimeout(() => {
          setLoading(false)
        }, 5000)
      }
    }
  }

  const handleImport = async (items: BoxItem[], mode: BoxComMode) => {
    setFormResult(false)
    if (onImport) {
      try {
        setImportLoading(true)
        await onImport(items, mode)
        setCheckItems([])
      } finally {
        setImportLoading(false)
      }
    }
  }

  useEffect(() => {
    if (loading) {
      // 非广播搜索
      if (type !== 1) {
        if (time) {
          clearTimeout(time)
        }
        setLoading(false)
      }
    }
  }, [boxItems])

  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      title={formatMessage({ id: 'app.box.toolbar.import' })}
      visible={visible}
      width={700}
      onCancel={() => onVisibleChange?.(false)}
      cancelButtonProps={{ style: { display: 'none' } }}
      onOk={() => setFormResult(true)}
      okText={formatMessage({ id: 'app.modal.import' })}
      okButtonProps={{
        disabled: checkItems.length <= 0,
        loading: importLoading
      }}
    >
      <Spin spinning={loading}>
        <BoxImport
          formResult={formResult}
          data={boxItems}
          importTypes={importTypes}
          onFileSelect={onFileSelect}
          onSearch={handleSearch}
          onTypeChange={onTypeChange}
          onImport={handleImport}
          onChange={setCheckItems}
        />
      </Spin>
    </Modal>
  )
}
